module.exports = __webpack_public_path__ + "media/images/main_blog_sp-6801280bf2621a4aa38bdc121e852cd3.png";